import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Share2 } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { InGameShareModal } from "./InGameShareModal";

interface InGameShareProps {
  puzzleNumber: number;
  guessCount: number;
  results: Array<Array<"correct" | "present" | "absent">>;
}

export function InGameShare({ puzzleNumber, guessCount, results }: InGameShareProps) {
  const [modalOpen, setModalOpen] = useState(false);

  if (guessCount === 0) return null;

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setModalOpen(true)}
            className="h-8 w-8 text-primary/80 hover:text-primary hover:bg-primary/10"
            aria-label="Share progress"
          >
            <Share2 className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Share progress</p>
        </TooltipContent>
      </Tooltip>

      <InGameShareModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        puzzleNumber={puzzleNumber}
        guessCount={guessCount}
        results={results}
      />
    </>
  );
}
